import React, { useState } from 'react';
import Popup from 'reactjs-popup';
import axios from 'axios';

const ModalModifyWireguard = ({ isVisible, onClose, choosenClientWireguard }) => {
    
    let token = localStorage.getItem("token");
    const [values, setValues] = useState({
        id: '',
        nom: '',
        adresse_ip: '',
    })

    const handleClose = (e) => {
        if (e.target.id === "wrapper") onClose();
    }

    if (choosenClientWireguard.id !== values.id) setValues({ ...values, ...choosenClientWireguard })

    // console.log( choosenClient);

    const headers = {
        'x-access-token': token,
        'Content-Type': 'application/json'
    };
    const deleteClient = (e) => {
        e.preventDefault();
        let data = {
            id: values.id
        }
        axios.delete(`${process.env.REACT_APP_IP}:${process.env.REACT_APP_PORT}/delete_client_wireguard`,{headers, data})
            .then((res) => {
                console.log(res);
                // navigate('/listusers');
                window.location.reload(false);
            }).catch(err => console.log(err))
        
    }
    const handleSubmit = (e) => {
        e.preventDefault();
        let error = document.getElementById('error');
        error.innerHTML = '';
        if(values.nom === '' || values.adresse_ip === ''){
            error.innerHTML = "Veuillez renseigner tout les champs"
        }else{
            axios.put(`${process.env.REACT_APP_IP}:${process.env.REACT_APP_PORT}/update_client_wireguard`, values)
            .then(res => {
                console.log(res);
                window.location.reload(false);
            }).catch(err => console.log(err))
        }
    }

    const close = () => {
        let divTooltip = document.getElementById('popup-2');
        divTooltip.style.display = "none"
    }
    
    if (!isVisible) return null;
    return (
        <div className='fixed inset-0 z-50 flex items-center justify-center bg-slate-900/50 backdrop-blur-sm p-4' id="wrapper" onClick={handleClose}>
            <div className='bg-white rounded-2xl shadow-2xl w-full max-w-lg max-h-[85vh] overflow-y-auto'>
                <div className="flex items-center justify-between border-b border-slate-200 px-6 py-4">
                    <h2 className="text-lg font-semibold text-slate-800">Modifier le client Wireguard</h2>
                    <button className='text-slate-400 hover:text-slate-600 text-xl leading-none' onClick={() => onClose()}>✕</button>
                </div>
                <form className="p-6" onSubmit={handleSubmit}>
                    <div className="mb-4">
                        <label htmlFor="nom" className="mb-1 block text-xs font-semibold uppercase tracking-wide text-slate-500">Nom Client</label>
                        <input type="text" name="nom" id="nom" className="w-full rounded-lg border border-slate-300 bg-white px-3 py-2 text-sm text-slate-800 focus:border-indigo-500 focus:outline-none focus:ring-2 focus:ring-indigo-500/30" placeholder="Nom du client" required onChange={e => setValues({ ...values, nom: e.target.value })} value={values.nom} />
                    </div>
                    <div className="mb-4">
                        <label htmlFor="adresse_ip" className="mb-1 block text-xs font-semibold uppercase tracking-wide text-slate-500">Adresse IP</label>
                        <input type="text" name="adresse_ip" id="adresse_ip" className="w-full rounded-lg border border-slate-300 bg-white px-3 py-2 text-sm text-slate-800 focus:border-indigo-500 focus:outline-none focus:ring-2 focus:ring-indigo-500/30" placeholder="0.0.0.0" required onChange={e => setValues({ ...values, adresse_ip: e.target.value })} value={values.adresse_ip} />
                    </div>
                    <div className='flex justify-between gap-3'>
                        <button type="submit" className="rounded-lg bg-indigo-500 px-4 py-2 text-sm font-medium text-white hover:bg-indigo-600">Enregistrer</button>
                        <Popup trigger=
                            {<button type="button" className="rounded-lg bg-red-600 px-4 py-2 text-sm font-medium text-white hover:bg-red-700" > Supprimer </button>}
                            position="right center">
                            <div>Est-ce votre dernier mot?</div>
                            <div className="flex justify-between gap-2">
                                <button type="button" className="rounded-lg bg-indigo-500 px-3 py-2 text-sm font-medium text-white hover:bg-indigo-600" onClick={deleteClient}> Accepter </button>
                                <button type="button" className="rounded-lg border border-slate-200 bg-white px-3 py-2 text-sm font-medium text-slate-700 shadow-sm hover:bg-slate-50" onClick={close}> Annuler </button>
                            </div>
                        </Popup>
                    </div>
                    <div className="py-4 text-center">
                        <p id="error" className='text-red-600'></p>
                    </div>
                </form>
            </div>
        </div>
    )
}

export default ModalModifyWireguard;